// ═══════════════════════════════════════════════════════════════
// MainStreet — Domain Constants
// Ported from mainstreet-embedded.html
// ═══════════════════════════════════════════════════════════════

import { semantic } from '../../lib/colors';
export interface SectorType {
  id: string;
  label: string;
  icon: string;
}

export interface OpStatus {
  id: string;
  label: string;
  color: string;
}

export interface LabeledOption {
  id: string;
  label: string;
}

// ── Sector Types (19) ────────────────────────────────────────
export const SECTOR_TYPES: SectorType[] = [
  { id: 'healthcare',     label: 'Healthcare & Medical',       icon: 'IconBuildingHospital' },
  { id: 'food_supply',    label: 'Food Supply & Grocery',      icon: 'IconToolsKitchen2' },
  { id: 'fuel_energy',    label: 'Fuel & Energy',              icon: 'IconGasStation' },
  { id: 'lodging',        label: 'Lodging & Hospitality',      icon: 'IconBed' },
  { id: 'manufacturing',  label: 'Manufacturing',              icon: 'IconBuildingFactory2' },
  { id: 'retail',         label: 'Retail',                     icon: 'IconBuildingStore' },
  { id: 'financial',      label: 'Financial Services',         icon: 'IconBuildingBank' },
  { id: 'transportation', label: 'Transportation & Logistics', icon: 'IconTruck' },
  { id: 'construction',   label: 'Construction & Trades',      icon: 'IconHelmet' },
  { id: 'education',      label: 'Education',                  icon: 'IconSchool' },
  { id: 'childcare',      label: 'Childcare',                  icon: 'IconFriends' },
  { id: 'agriculture',    label: 'Agriculture',                icon: 'IconTractor' },
  { id: 'technology',     label: 'Technology & Telecom',       icon: 'IconCpu' },
  { id: 'utilities',      label: 'Utilities',                  icon: 'IconBolt' },
  { id: 'government',     label: 'Government Services',        icon: 'IconBuildingCastle' },
  { id: 'nonprofit',      label: 'Non-Profit / NGO',           icon: 'IconHeartHandshake' },
  { id: 'religious',      label: 'Religious Organization',     icon: 'IconBuildingChurch' },
  { id: 'small_business', label: 'Small Business',             icon: 'IconShoppingBag' },
  { id: 'other',          label: 'Other',                      icon: 'IconBuilding' },
];

// ── Operational Status (6) ───────────────────────────────────
export const OP_STATUS: OpStatus[] = [
  { id: 'pending',       label: 'Pending Registration',    color: 'violet' },
  { id: 'operational',   label: 'Fully Operational',       color: 'green' },
  { id: 'limited',       label: 'Limited Operations',      color: 'yellow' },
  { id: 'closed_temp',   label: 'Temporarily Closed',      color: 'red' },
  { id: 'closed_damage', label: 'Closed — Damaged',        color: 'red' },
  { id: 'destroyed',     label: 'Destroyed',               color: 'red' },
  { id: 'unknown',       label: 'Unknown / No Contact',    color: 'gray' },
];

// ── Resource Offer Types (11) ────────────────────────────────
export const OFFER_TYPES: LabeledOption[] = [
  { id: 'space',         label: 'Space / Facilities' },
  { id: 'generator',     label: 'Generator / Power' },
  { id: 'food',          label: 'Food / Water' },
  { id: 'transport',     label: 'Transportation' },
  { id: 'labor',         label: 'Labor / Volunteers' },
  { id: 'equipment',     label: 'Equipment / Tools' },
  { id: 'supplies',      label: 'Supplies / Materials' },
  { id: 'lodging',       label: 'Lodging / Shelter' },
  { id: 'communication', label: 'Communication Equipment' },
  { id: 'medical',       label: 'Medical Supplies' },
  { id: 'other',         label: 'Other' },
];

// ── Damage Types (11) ────────────────────────────────────────
export const DAMAGE_TYPES: LabeledOption[] = [
  { id: 'roof',           label: 'Roof Damage' },
  { id: 'structural',     label: 'Structural Damage' },
  { id: 'flooding',       label: 'Flooding / Water' },
  { id: 'fire',           label: 'Fire Damage' },
  { id: 'wind',           label: 'Wind Damage' },
  { id: 'power',          label: 'Power Loss' },
  { id: 'water_supply',   label: 'Water Supply Loss' },
  { id: 'gas_leak',       label: 'Gas Leak' },
  { id: 'hazmat_release', label: 'Hazmat Release' },
  { id: 'access_blocked', label: 'Access Blocked' },
  { id: 'other',          label: 'Other' },
];

// ── Building Types (9) ───────────────────────────────────────
export const BUILDING_TYPES: LabeledOption[] = [
  { id: 'commercial',    label: 'Commercial' },
  { id: 'industrial',    label: 'Industrial' },
  { id: 'office',        label: 'Office' },
  { id: 'retail_space',  label: 'Retail Space' },
  { id: 'warehouse',     label: 'Warehouse' },
  { id: 'medical',       label: 'Medical' },
  { id: 'restaurant',    label: 'Restaurant' },
  { id: 'mixed_use',     label: 'Mixed Use' },
  { id: 'other',         label: 'Other' },
];

// ── Sector Colors (for map markers & charts) ──────────────────
export const SECTOR_COLORS: Record<string, string> = {
  healthcare: semantic.error,
  food_supply: '#A67103',
  fuel_energy: '#DF461B',
  lodging: '#A627FF',
  manufacturing: '#7B7D7F',
  retail: '#0285C4',
  financial: '#019184',
  transportation: '#07963F',
  construction: '#92400e',
  education: '#6d28d9',
  childcare: '#ec4899',
  agriculture: '#07963F',
  technology: '#0284c7',
  utilities: '#eab308',
  government: '#09015E',
  nonprofit: '#be185d',
  religious: '#AB6FFE',
  small_business: '#03AC9E',
  other: '#94a3b8',
};
